module.exports = __webpack_public_path__ + "static/media/twitter_white.058f65e4.svg";